import React, { useEffect, useState } from 'react'
import AllRoutes from '../nametitle/AllRoutes';
import { LoadAllDon } from '../actions/Activites/Dons';
import LoaderBootStrap from '../components/admin/dasboard/LoaderBootStrap';

const DonPage = () => {
    const [DonList, setDonList] = useState([]);

    useEffect(() => {
        LoadAllDon(setDonList);
    }, [])
    return (
        <div>
            <div className="w-full flex flex-row space-y-3 justify-center">

                <div className="col-lg-8 space-y-6 mx-5 my-5">
                    <div className="py-2 ">
                        <div className="text-3xl font-bold translatable">Projet de dons</div>
                    </div>

                    <div className="mb-5">
                        <div className="input-group">
                            <input type="text" className="form-control p-3" placeholder="reccherche ..." />
                            <button className="btn btn-primary px-4"><i className="bi bi-search"></i></button>
                        </div>
                    </div>
                    
                    <div className="blog-item mb-8">
                        {
                            DonList && DonList.length > 0 ?
                                (
                                    DonList.map((item) => {
                                        return (
                                            <div className="rounded-[30px] row g-0 bg-primary text-light overflow-hidden">
                                                <div className="col-12 col-sm-5 h-100">
                                                    <img className="img-fluid h-100" src="img/blog-1.jpg" style={{ objectFit: "cover" }} />
                                                </div>
                                                <div className="col-12 col-sm-7 h-100 d-flex flex-column justify-content-center">
                                                    <div className="p-4">
                                                        <div className="d-flex mb-3">
                                                            {/* <small className="me-3"><i className="bi bi-bookmarks me-2"></i>Web Design</small> */}
                                                            <small><i className="bi bi-calendar-date me-2"></i><span className="translatable">{item.date}</span></small>
                                                        </div>
                                                        <h5 className="text-uppercase mb-3 translatable">{item.title}</h5>
                                                        <p className="translatable">{item.description}</p>
                                                        <a className="text-primary text-uppercase " href={`/${AllRoutes.evenement}/:id`}><span className="translatable">Voire plus</span><i className="bi bi-chevron-right"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                ) :
                                <LoaderBootStrap />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DonPage;
